<div *ngIf="capture.candidate.highValue">
  <span class="indicator-pill indicator-pill-green indicator-pill-full-width">
    High Value
  </span>
</div>
